import React, { FC } from 'react';
import { useInspectionsLogs } from '@/api/Inspections';
import { Inspection } from '@/types';
import { EventViewerDataGrid } from './components/EventViewerDataGrid';

export const EventViewer: FC<{ inspection: Inspection }> = ({
  inspection,
}: {
  inspection: Inspection;
}) => {
  const { data, isFetching, refetch } = useInspectionsLogs(inspection.id);

  const dataSource = (data?.entities || []).map((log) => {
    let logData: any = null;
    try {
      logData = JSON.parse(log.eventData);
    } catch {
      logData = null;
    }
    log.eventObject = logData;
    return log;
  });

  return (
    <EventViewerDataGrid
      loading={isFetching}
      dataSource={dataSource}
      reload={refetch}
      inspectionId={inspection.id}
    />
  );
};
